<app-top [showStartLink]="false">
  <h1>Celltalsakuten</h1>
  <h2>Bättre juverhälsa och lägre celltal</h2>
  <p>
    Celltalsakuten ger råd om förebyggande åtgärder för bättre juverhälsa.
    <br />Använd pyramiderna för att planera djurhälsoarbetet tillsammans med alla som mjölkar och sköter djuren. <br /><br />Börja med de
    nedersta byggstenarna och lägg en stabil grund, arbeta er sedan uppåt i pyramiden för en juverhälsa i toppklass!
  </p>
</app-top>

<nav class="menu">
  <a routerLink="/besattning" class="menu-item" appMainButton color="orange" icon="cell">
    <strong>Din besättning</strong>
    Få råd utifrån ditt nuläge
  </a>

  <a routerLink="/juverhalsa" class="menu-item" appMainButton color="gras" icon="udder">
    <strong>Räkna på juverhälsa</strong>
    Se hur mycket du kan tjäna
  </a>

  <a routerLink="/pyramiderna" class="menu-item" appMainButton color="himmel" icon="pyramid">
    <strong>Pyramiderna</strong>
    Råd för bättre juverhälsa
  </a>
</nav>
